export default __webpack_public_path__ + "static/media/54.afab62ed.jpg";